import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@mui/material/Checkbox';

const CustomCheckBox = ({
    name,
    datatestid,
    ...rest
}) => {
    const {
        ["data-testid"]: dataTestIdProp,
        ["data-testId"]: dataTestIdCamel,
        ...otherProps
    } = rest;

    const resolvedTestId = dataTestIdProp || dataTestIdCamel || datatestid || name || "custom-checkbox";

    return (
        <Checkbox
            data-testid={resolvedTestId}
            name={name}
            {...otherProps}
        />

    )
}

CustomCheckBox.propTypes = {
    checked: PropTypes.bool,
    disableRipple: PropTypes.bool,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    datatestid: PropTypes.string
}

CustomCheckBox.defaultProps = {
    id: 'custom-checkbox',
    disableRipple: true
}

export default CustomCheckBox;